import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SetPortalPreferencesAPI } from '../../services';
import { SetUserPreferences } from '../../redux/actions/user.js';
import { Link, useNavigate } from 'react-router-dom';
import Notifications from '../features/Notifications.jsx';
import Modal from '../features/Modal.jsx';
import { LanguageLoader } from '../../assets/languages/index.js';

const TopNavigation = ({sidebarStatus, HamburgerClick}) =>
{
	const [darkMode, SetDarkMode] = useState(document.documentElement.dataset.theme === 'Dark');
	const [prevTheme, SetPrevTheme] = useState(document.documentElement.dataset.theme === 'Dark' ? 'SG' : document.documentElement.dataset.theme );
	const [searchString, SetSearchString] = useState('');
	const [fallDown, SetFallDown] = useState(false);
	const current_user = useSelector((state) => state.current_user);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const handleSearch = () => 
	{
		SetFallDown(true);
		navigate(`/search/${searchString}`);
	};
	const handleSearchByEnter = (e) =>
	{
		if(e.keyCode === 13)
		{
			handleSearch();
		}
	}
	const DarkModeHandler = async (isDark) =>
	{
		SetDarkMode(isDark);
		if(isDark)
		{
			const data = { "theme" : 'Dark', "language" : preferences.language, "search" : preferences.search};
			const APIResponse = await SetPortalPreferencesAPI(data);
			if(Object.keys(APIResponse).length)
			{
				SetPrevTheme(document.documentElement.dataset.theme);
				localStorage.setItem('theme', 'Dark');
				dispatch(SetUserPreferences(APIResponse));
			}
			document.documentElement.dataset.theme = 'Dark';
		}
		else
		{
			const data = { "theme" : prevTheme, "language" : preferences.language, "search" : preferences.search};
			const APIResponse = await SetPortalPreferencesAPI(data);
			if(Object.keys(APIResponse).length)
			{
				SetPrevTheme(document.documentElement.dataset.theme);
				localStorage.setItem('theme', prevTheme);
				dispatch(SetUserPreferences(APIResponse));
			}
			document.documentElement.dataset.theme = prevTheme;
		}
	}

	const menuIcon = (sidebarStatus === 'expand' && window.innerWidth > 640) ? '/images/chevron.svg' : '/images/menu.svg';

	return(
		<nav className="flex items-center justify-between md:wrapper md:py-3">
			<div className="flex items-center gap-3">
				<span className="hidden border p-2 rounded-full border-secondary cursor-pointer md:block" onClick={HamburgerClick}>
					<img src={menuIcon} alt="menu" className="w-5 dark:invert"/>
				</span>
				<Link to={'/profile'} className='flex items-center'>
				{/* <img src='/images/profile.jpg' className='w-[40px] h-[40px] object-cover rounded-full border-3 border-secondary' alt="profile"/> */}
					<i className='fa fa-user-circle text-4xl text-primary'></i>
					<div className="flex flex-col">
						<span className="mx-5 text-secondaryFont md:text-primaryFont">{current_user.full_name}</span>
						<span className="mx-5 mt-1 text-xs text-secondaryFont md:text-primaryFont">{current_user.account.name}</span>
					</div>
				</Link>
			</div>
			<div className="flex gap-4">
				<Modal handler={<i className="p-2 fa fa-search text-primary cursor-pointer"></i>} fallDown={fallDown}>
					<div className='flex flex-wrap'>
						<div className="Field_Container">
							<label>{language.FILTER.SEARCH}</label>
							<input type="text" onKeyUp={handleSearchByEnter} onChange={(e) => SetSearchString(e.target.value)} value={searchString} />
						</div>
						<div className="Field_Container">
							<button className='btn btn-success mt-6 h-11 w-10 px-0' onClick={handleSearch}><i className='fa fa-search'></i></button>
						</div>
					</div>
				</Modal>
				<Notifications/>
				<i className={"p-2 fa text-primary cursor-pointer"+(darkMode ? ' fa-sun' : ' fa-moon')} onClick={e => {DarkModeHandler(!darkMode)}}></i>
			</div>
			<div className="border border-secondary cursor-pointer rounded-full p-1 hover:text-secondary md:hidden" onClick={HamburgerClick}>
				<img src={menuIcon} alt="menu" className="w-6 invert"/>
			</div>
		</nav>
	);
}

export default TopNavigation;